import { FaTrash } from 'react-icons/fa';

const TableFile = ({ files, setFiles}) => {
    //console.log(files);

    // const removeFile = (fileToDelete) => {
    //     console.log(fileToDelete, files);
    //     let newFiles = files.filter((file) => {
    //         return file.name !== fileToDelete.name;
    //     });
    //     setFiles(newFiles);
    // }
    return (
        <table className="mt-6">
            <thead>
                <tr>
                    <th>Selected File</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>        
                    {     
                        <tr>
                            <td>{files.name}</td>
                            <td><FaTrash color="#af0e19" onClick={() => setFiles('')}/></td> 
                        </tr>
                    
                    }     
            </tbody>
        </table>
     );
}
 
export default TableFile;